<template>
    <div>
        <label
            v-if="label"
            :for="selectId"
        >{{ label }}</label>
        <select
            :id="selectId"
            :key="selectKey"
            :value="selectedValue"
            :disabled="disabled || readonly || isLoading"
            :required="required"
            class="form-control"
            :class="inputClass"
            @change="onChange"
        >
            <option
                v-if="isLoading"
                value=""
                disabled
            >
                Loading...
            </option>
            <option
                v-if="optional && !isLoading"
                value=""
            >
                N/A
            </option>
            <option
                v-else-if="placeholder && !isLoading"
                value=""
                disabled
            >
                {{ placeholder }}
            </option>
            <template v-if="!isLoading">
                <option
                    v-for="reg in options"
                    :key="reg"
                    :value="reg"
                >
                    {{ reg }}
                </option>
            </template>
        </select>
        <error
            v-if="errors"
            :errors="errors"
            :name="errorName"
        />
    </div>
</template>

<script>
import VehicleService from '../services/VehicleService';

export default {
    name: 'VehicleSelect',

    props: {
        value: {
            type: [String, null],
            default: null,
        },
        vehicles: {
            type: Array,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        id: {
            type: String,
            default: 'vehicle_reg',
        },
        optional: {
            type: Boolean,
            default: false,
        },
        optionalValue: {
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Object,
            default: null,
        },
        errorName: {
            type: String,
            default: 'vehicle_reg',
        },
        inputClass: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loadedVehicles: [],
            fetching: false,
        };
    },

    computed: {
        selectId() {
            return this.id;
        },

        isLoading() {
            return this.loading || this.fetching;
        },

        normalizedValue() {
            if (this.optional && (this.value === null || this.value === undefined || this.value === '')) {
                return '';
            }
            if (typeof this.value === 'string') {
                return this.value.trim();
            }
            return this.value;
        },

        selectedValue() {
            return this.normalizedValue;
        },

        selectKey() {
            if (this.isLoading) {
                return 'loading';
            }

            return `loaded-${this.options.length}-${this.selectedValue || ''}`;
        },

        vehicleRegs() {
            const source = this.vehicles !== null ? this.vehicles : this.loadedVehicles;
            const regs = [];

            for (let i = 0; i < source.length; i++) {
                const vehicle = source[i];
                if (typeof vehicle === 'string') {
                    regs.push(vehicle.trim());
                    continue;
                }
                if (vehicle && vehicle.registration) {
                    regs.push(vehicle.registration.trim());
                }
            }

            return regs;
        },

        options() {
            const options = [];
            for (let i = 0; i < this.vehicleRegs.length; i++) {
                options.push(this.vehicleRegs[i]);
            }

            const current = this.normalizedValue;
            if (current && options.indexOf(current) === -1) {
                options.push(current);
            }

            return options;
        },
    },

    created() {
        if (this.vehicles === null) {
            this.loadVehicles();
        }
    },

    methods: {
        loadVehicles() {
            this.fetching = true;
            VehicleService.index().then((res) => {
                this.loadedVehicles = res.data;
            }).catch((err) => {
                console.error(err);
            }).then(() => {
                this.fetching = false;
            });
        },

        onChange(event) {
            if (this.isLoading) {
                return;
            }

            const selectedIndex = event.target.selectedIndex;
            if (this.optional && selectedIndex === 0) {
                this.$emit('input', this.optionalValue);
                this.$emit('change', this.optionalValue);
                return;
            }

            const value = event.target.value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/VehicleSelectComponent.vue